//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import getCookie from '@/utils/getCookie';
import Loader from '@/components/autoscale/loader.vue';
import * as Sentry from '@sentry/vue';

export default {
  components: { Loader },
  props: {
    // На чате появляется кнопка выхода, если он открыт через
    // полноэкранный просмотр стрима\чата с телефона
    closable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      chatUrl: '',
      buzy: true,
      gtmIntervalTimer: null,
      embyTerminatorTimer: null,
      isEmbyChatLoaded: false,
      isGetStreamChatLoaded: false,
    };
  },
  computed: {
    event() {
      return this.$store.state.event.data;
    },
    topic() {
      return this.$store.state.event.topic;
    },
    topicStatus() {
      return this.$store.getters['event/topicStatus'];
    },
    isSubscribed() {
      return this.$store.state.event.isSubscribed;
    },
    isChatLoaded() {
      return this.isEmbyChatLoaded || this.isGetStreamChatLoaded;
    },
  },
  watch: {
    topic() {
      this.generateChatUrl();
    },
    topicStatus() {
      this.generateChatUrl();
    },
    isSubscribed() {
      this.generateChatUrl();
    },
  },
  async mounted() {
    await this.generateChatUrl();

    this.sendGtmWebinarAttend();
    this.setIntervalForSendGtmWebinarAttend();

    window.addEventListener('message', this.messageEventListener.bind(this));
  },
  beforeDestroy() {
    clearTimeout(this.gtmIntervalTimer);
    clearTimeout(this.embyTerminatorTimer);
    window.removeEventListener('message', this.messageEventListener);
  },
  methods: {
    async generateChatUrl() {
      try {
        this.buzy = true;
        const aToken = getCookie({ name: 'a_token', cookies: document.cookie });
        const eventId = this.event.id;
        const topicId = this.topic.id;
        const isSubscribed = this.isSubscribed;
        const topicIsLive = this.topicStatus === 'live';
        const lang = this.$config.COUNTRY === 'br' ? 'pt' : 'es';

        const response = await this.$axios({
          method: 'post',
          url: `${this.$app.config.current.CMS_REST_API}/public/getEmbyChat/`,
          data: {
            eventId,
            topicId,
            ...(topicIsLive &&
              isSubscribed &&
              aToken && {
                aToken,
              }),
            lang,
          },
        });

        const chatUrl = response.data.data;
        this.$store.commit('event/SET_CHAT_URL', chatUrl);
        this.chatUrl = chatUrl;
      } catch (e) {
        console.error(e);
      }
    },
    onLoad() {
      this.buzy = false;
    },
    /** Отправить GTM метку с данными ивента */
    sendGtmWebinarAttend() {
      if (!this.event?.id) return;
      if (!this.topic?.id) return;

      const directionId = this.event.directionId;
      const direction =
        this.$store.getters['eventsList/GET_DIRECTION_BY_ID'](directionId);
      const directionName = direction?.name;

      const userEmail = this.$app?.user?.email;
      const topicId = this.topic?.id;

      const gtmData = {
        event: 'webinar_attend',
        schedule_event_name: this.event.name,
        schedule_event_type: this.event.type,
        schedule_event_id: this.event.id,
        schedule_event_slug: this.event.slug,

        schedule_event_direction: directionName,
        schedule_event_form_type: 'old',
        schedule_event_topic_status: this.topicStatus,
        user_email: userEmail,

        ...(topicId && {
          schedule_event_topic_id: topicId,
        }),
      };

      this.$gtm.push(gtmData);
    },
    /** GTM метка с данными ивента отправляется каждые 60 секунд */
    setIntervalForSendGtmWebinarAttend() {
      this.gtmIntervalTimer = setInterval(
        () => this.sendGtmWebinarAttend(),
        1000 * 60,
      );
    },
    /** Получение и обработка ивентов от фрейма чата */
    messageEventListener(e) {
      let data = {};

      if (e.data) {
        if (typeof e.data === 'string') {
          try {
            data = JSON.parse(e.data);
          } catch (e) {
            return;
          }
        } else {
          data = e.data;
        }
      }

      const type = data?.type;
      if (type === 'Emby.Loaded') {
        this.isEmbyChatLoaded = true;
        this.buzy = false;
      }

      if (type === 'GetStream.Loaded') {
        this.isGetStreamChatLoaded = true;
      }

      if (type === 'Emby.Alive') {
        this.checkAlive();
      }
    },
    sendErrorNotLoad() {
      Sentry.captureException(new Error('CHAT IS NOT LOADED'));
    },
    checkAlive() {
      clearTimeout(this.embyTerminatorTimer);

      this.embyTerminatorTimer = setTimeout(async () => {
        const successLoad = this.isChatLoaded || this.isGetStreamChatLoaded;

        if (!successLoad) {
          this.sendErrorNotLoad();
        }

        const iframe = document?.querySelector('.event-top__chat iframe');

        const parentNode = iframe?.parentNode;
        const clonedIframe = iframe?.cloneNode();

        if (!parentNode || !clonedIframe) return;

        parentNode.removeChild(iframe);
        parentNode.appendChild(clonedIframe);
      }, Number(this.$nuxt.$config.EMBY_TERMINATOR_TIMEOUT_DELAY));
    },
  },
};
